import { Alert, Snackbar } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    top: theme.spacing(9) + "!important",
  },
}));

export default function Notification(props) {
  const classes = useStyles();

  const { notify, setNotify } = props;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotify({
      ...notify,
      isOpen: false,
    });
  };

  return (
    <Snackbar
      open={notify.isOpen}
      autoHideDuration={5000}
      className={classes.root}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      // TransitionComponent={{transition:'TransitionRight'}}
      onClose={handleClose}
    >
       {/* severity= ["error","info","success","warning"]. */}
      <Alert severity={notify.type || 'info'} onClose={handleClose}>
        {notify.message}
      </Alert>
    </Snackbar>
  );
}
